<template>
  <v-dialog  width="900px" v-model="dialog">
    <v-card height="550px">
      <v-card-text class="h-100">
        <v-layout class="h-100">
          <v-flex md12>
            <v-layout class="h-100" column>
              <v-flex md1 class="text-xs-center">
                <span class="title pa-0">
                  Clientes en el proceso {{title}}
                </span>
              </v-flex>
              <v-flex class="text-xs-center">
                <vue-perfect-scrollbar>
                  <div style="height: 450px">
                    <pivot
                      v-if="dialog"
                      fields-label-text="Columnas activos"
                      columns-label-text="Totales activos"
                      available-colums-label-text="Totales disponibles"
                      available-fields-label-text="Columnas disponibles"
                      :data="data"
                      :filters="filters"
                      :fields-list="lists.fieldsList"
                      :columns-list="lists.columnsList"
                      :default-columns="defaultColumns"
                      @loading="clearData"
                      @loaded="setData"
                    />
                  </div>
                </vue-perfect-scrollbar>
              </v-flex>
              <v-flex>
                <v-layout class="h-100" justify-end align-end>
                  <v-btn flat  @click="$emit('close')">Cerrar</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import statusMixins from '@/mixins/status';
import Pivot from '@/components/global/report_datatables/Pivot';

export default {
  mixins: [
    statusMixins,
  ],
  components: {
    VuePerfectScrollbar,
    Pivot,
  },
  props: {
    filters: {
      required: true,
      type: Object,
    },
    show: {
      required: true,
      type: Boolean,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      data: [],
      defaultColumns: [
        {
          label: 'Total',
          value: 'quantity',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'dimentions',
    ]),
    dims() {
      if (this.dimentions.length) {
        return this.dimentions.map((item) => {
          const { title, name } = item;
          const obj = {};
          obj.label = title;
          obj.value = name;
          return obj;
        });
      }
      return [];
    },
    lists() {
      const lists = {
        fieldsList: [
          {
            label: 'Agencia',
            value: 'agency',
          },
          {
            label: 'Tramo',
            value: 'tranche',
          },
          {
            label: 'Vencimiento',
            value: 'due_day',
          },
          {
            label: 'Portafolio',
            value: 'portfolio_type',
          },
          {
            label: 'Tipo de cuenta',
            value: 'account_type',
          },
          {
            label: 'Agente',
            value: 'agent',
          },
          {
            label: 'Genero',
            value: 'gender',
          },
          {
            label: 'Grupo de edad',
            value: 'age_group',
          },
          ...this.dims,
        ],
        columnsList: [
          {
            label: 'Balance',
            value: 'balance',
          },
        ],
      };
      return lists;
    },
    title() {
      let title;
      if (this.id === 1) {
        title = 'archivo de lectura';
      } else if (this.id === 2) {
        title = 'antes de los filtros';
      } else if (this.id === 3) {
        title = 'despues de los filtros';
      } else if (this.id === 4) {
        title = 'cargados';
      }
      return title;
    },
    groupedRows() {
      return this.data.length ? _.groupBy(this.data, this.filters.first) : {};
    },
  },
  methods: {
    clearData() {
      this.data = [];
      this.isDataLoading = true;
    },
    setData($event) {
      this.data = $event;
      this.isDataLoading = false;
    },
  },
  watch: {
    id(val) {
      this.filters.type_id = val;
    },
    show(show) {
      this.dialog = show;
    },
    dialog(dialog) {
      if (!dialog) {
        this.columns = {
          first: 'quantity',
          second: '',
        };
        this.filters = {
          first: '',
          second: '',
          type: 'daily',
          type_id: 1,
          date: moment().format('YYYY-MM-DD'),
        };
        this.$emit('close');
        this.clearData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/daily_load/InfoModal.vue